import Funcs from 'common/helpers/Funcs';
import Realms from 'realm/Realms';

export default class BaseController {
  model = 'Base';

  convertToObject(realmObject) {
    if (!Realms.getInstance()) return 0;
    try {
      const schema = Realms.config.schema;
      const find = schema.find((e) => e.name === this.model);
      if (!find) throw new Error('Can not found schema ' + this.model);
      return Realms.convertToObject(realmObject, find);
    } catch (err) {
      Funcs.log(err);
    }
    return 1;
  }

  convertToObjects(realmObjects) {
    if (!Realms.getInstance()) return 0;
    try {
      const schema = Realms.config.schema;
      const find = schema.find((e) => e.name === this.model);
      if (!find) throw new Error('Can not found schema ' + this.model);
      return Realms.convertToObjects(realmObjects, find);
    } catch (err) {
      Funcs.log(err);
    }
    return 1;
  }

  genNewId() {
    if (!Realms.getInstance()) return 0;
    try {
      let results = Realms.getInstance()
        .objects(this.model)
        .sorted('id');
      const id = results.length > 0 ? results[results.length - 1].id + 1 : 1;
      return id;
    } catch (err) {
      Funcs.log(err);
    }
    return 1;
  }

  add(data, update = true) {
    if (!this.model) {
      Funcs.log('Error: Model is null');
      return;
    }
    return new Promise((resolve, reject) => {
      try {
        Realms.getInstance().write(() => {
          const realmObj = Realms.getInstance().create(this.model, data, update);
          resolve(realmObj);
        });
      } catch (err) {
        Funcs.log(err, data);
        reject(err);
      }
    });
  }

  getAll = () =>
    new Promise((resolve, reject) => {
      try {
        let allData = Realms.getInstance().objects(this.model);
        resolve(allData);
      } catch (err) {
        Funcs.log(err);
        reject(err);
      }
    });

  getById = (id, raw = false) =>
    new Promise((resolve, reject) => {
      try {
        let object = Realms.getInstance().objectForPrimaryKey(this.model, id);
        if (raw) object = this.convertToObject(object);
        resolve(object);
      } catch (err) {
        Funcs.log(err, { id });
        reject(err);
      }
    });

  getBy = (key, value, raw = false) =>
    new Promise((resolve, reject) => {
      try {
        let object = Realms.getInstance()
          .objects(this.model)
          .filtered(`${key}=${value}`);
        if (raw) object = this.convertToObjects(object);
        resolve(object);
      } catch (err) {
        Funcs.log(err, { key, value });
        reject(err);
      }
    });

  getByQuery = (query) =>
    new Promise((resolve, reject) => {
      try {
        let object = Realms.getInstance()
          .objects(this.model)
          .filtered(`${query}`);
        resolve(object);
      } catch (err) {
        Funcs.log(err);
        reject(err);
      }
    });

  delete = (id) =>
    new Promise((resolve, reject) => {
      try {
        Realms.getInstance().write(() => {
          let deletingVideoDownload = Realms.getInstance().objectForPrimaryKey(this.model, id);
          Realms.getInstance().delete(deletingVideoDownload);
          resolve();
        });
      } catch (err) {
        Funcs.log(err);
        reject(err);
      }
    });

  deleteObjects = (objects) =>
    new Promise((resolve, reject) => {
      try {
        Realms.getInstance().write(() => {
          Realms.getInstance().delete(objects);
          resolve(objects);
        });
      } catch (err) {
        Funcs.log(err);
        reject(err);
      }
    });

  deleteBy = (key, value) =>
    new Promise(async (resolve, reject) => {
      try {
        let objects = await this.getBy(key, value);
        await this.deleteObjects(objects);
        resolve();
      } catch (err) {
        Funcs.log(err);
        reject(err);
      }
    });
}
